// @feature-flag-dni (for GUEST users)
export const isDniFeatureEnabled = (): boolean => {
  const rawDniFlag = import.meta.env.VITE_FEATURE_FLAG_DNI;
  const isTestMode = import.meta.env.MODE === 'test';

  // In test runs the env flag might be missing (as in CI). Default to true so
  // DNI scenarios remain enabled and deterministic in tests.
  if (isTestMode && !JSON.parse(rawDniFlag || 'false')) return true;

  return rawDniFlag === 'true';
};

// @feature-flag-dni-registered
export const isDniRegisteredFeatureEnabled = (): boolean => {
  const rawDniRegisteredFlag = import.meta.env.VITE_FEATURE_FLAG_DNI_REGISTERED;
  const isTestMode = import.meta.env.MODE === 'test';

  // In test runs the env flag might be missing (as in CI). Default to true so
  // DNI scenarios remain enabled and deterministic in tests.
  if (isTestMode && !JSON.parse(rawDniRegisteredFlag || 'false')) return true;

  return rawDniRegisteredFlag === 'true';
};

// @feature-flag-points-register
export const isAcceptedPointsTermsAndConditionsEnabled = (): boolean => {
  const acceptedPointsTermsAndConditionsEnabled = import.meta.env
    .VITE_FEATURE_FLAG_POINTS_TERMS;
  const isTestMode = import.meta.env.MODE === 'test';

  // In test runs the env flag might be missing (as in CI). Default to true so
  // DNI registered scenarios remain enabled and deterministic in tests.
  if (
    isTestMode &&
    !JSON.parse(acceptedPointsTermsAndConditionsEnabled || 'false')
  )
    return true;

  return acceptedPointsTermsAndConditionsEnabled === 'true';
};

export default {
  isDniFeatureEnabled,
  isDniRegisteredFeatureEnabled,
  isAcceptedPointsTermsAndConditionsEnabled
};
